module.exports = __webpack_public_path__ + "static/media/tsb3ru.4d586008.pdf";